export function FileExportIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Export"
    >
      <path
        d="M5.529 2.71875H2.64691C2.42046 2.71875 2.23518 2.90156 2.23518 3.125V12.875C2.23518 13.0984 2.42046 13.2812 2.64691 13.2812H9.23454C9.46099 13.2812 9.64626 13.0984 9.64626 12.875V11.6562H10.8814V12.875C10.8814 13.7713 10.1429 14.5 9.23454 14.5H2.64691C1.73854 14.5 1 13.7713 1 12.875V3.125C1 2.22871 1.73854 1.5 2.64691 1.5H6.08225C6.51971 1.5 6.93916 1.67012 7.24795 1.9748L10.4002 5.0877C10.709 5.39238 10.8814 5.80625 10.8814 6.23789V8.00254H9.64626V6.78379H7.38177C6.3576 6.78379 5.529 5.96621 5.529 4.95566V2.72129V2.71875ZM7.38177 9.21875H12.8912L12.0935 8.43164C11.8516 8.19297 11.8516 7.80703 12.0935 7.5709C12.3354 7.33477 12.7265 7.33223 12.9658 7.5709L14.8186 9.39902C15.0605 9.6377 15.0605 10.0236 14.8186 10.2598L12.9658 12.0879C12.7239 12.3266 12.3328 12.3266 12.0935 12.0879C11.8541 11.8492 11.8516 11.4633 12.0935 11.2271L12.8912 10.44H7.38177C7.03952 10.44 6.76418 10.1684 6.76418 9.83066C6.76418 9.49297 7.03952 9.22129 7.38177 9.22129V9.21875ZM9.13418 5.5625L6.76418 3.22402V4.95312C6.76418 5.29082 7.03952 5.5625 7.38177 5.5625H9.13418Z"
        fill="currentColor"
      />
    </svg>
  );
}
